// Impressum, Text vom Kunden übernommen.
export const IMPRESSUM = {
  intro: ["Angaben gemäß § 5 TMG"],
  sections: [
    {
      h: "Schwimmschule Manta",
      items: ["Inhaberin: Melissa Siebenlist\nKarlstraße 56\n64285 Darmstadt"],
    },
    {
      h: "Kontakt",
      items: ["Telefon: +49 176 59905968\nE-Mail: info@schwimmschulemanta.de\nWebsite: https://schwimmschulemanta.de"],
    },
    {
      h: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
      items: ["Melissa Siebenlist\nKarlstraße 56\n64285 Darmstadt"],
    },
    {
      h: "Hinweis zur Verbraucherstreitbeilegung",
      items: [
        "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS-Plattform) bereit. Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
      ],
    },
  ],
};
